module.exports = __webpack_public_path__ + "308f1fd10325e6efaf3ddbcb1d805ab2.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/share-slogan-4.png
// module id = 504
// module chunks = 0